import { render, staticRenderFns } from "./MoreGamesEnd.vue?vue&type=template&id=85b997d4&"
import script from "./MoreGamesEnd.vue?vue&type=script&lang=js&"
export * from "./MoreGamesEnd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports